import React, { useState } from 'react';
import './sl.css';

const board = Array.from({ length: 10 }, (_, i) =>
  Array.from({ length: 10 }, (_, j) => 100 - (i * 10 + j))
);

const snakes = {
  17: 7,
  54: 34,
  62: 19,
  64: 60,
  87: 24,
  93: 73,
  95: 75,
  99: 78
};
const openUrl = () => {
  window.open('https://draftj.in', '_blank');
}
const ladders = {
  1: 38,
  4: 14,
  9: 31,
  21: 42,
  28: 84,
  36: 44,
  51: 67,
  71: 91,
  80: 100
};

function SnakeL() {
  const [position, setPosition] = useState(1);
  const [dice, setDice] = useState(1);

  const rollDice = () => {
    const roll = Math.floor(Math.random() * 6) + 1;
    setDice(roll);
    let newPosition = position + roll;
    if (newPosition > 100) return;
    if (snakes[newPosition]) {
      newPosition = snakes[newPosition];
    } else if (ladders[newPosition]) {
      newPosition = ladders[newPosition];
    }
    setPosition(newPosition);
  };

  return (
    <div className="AppSnake"><br/><br/>
        <h1>Invisible Snake and Ladder  &nbsp; &nbsp;  <button onClick={openUrl}>Home</button></h1>
      <div className="boardsnk">
        {board.map((row, rowIndex) => (
          <div className="row" key={rowIndex}>
            {row.map((cell) => (
              <div className={`cell ${cell === position ? 'active' : ''}`} key={cell}>
                {cell}
              </div>
            ))}
          </div>
        ))}
      </div>
      <button onClick={rollDice}>Roll Dice</button>
      <p>Dice: {dice}</p>
      <p>Position: {position}</p>
    </div>
  );
}

export default SnakeL;
